/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import { connect } from "react-redux";
import { servicios } from "../properties";

const mapState = (state) => {
	return {
		beneficiosGnp: state.beneficiosGnp.listaBeneficios,
		showBeneficiosText: state.beneficiosGnp.showBeneficiosText,
		dispositivo: state.global.dispositivo,
		clienteunico: state.global.uid,

		paso: state.directorio.paso,
		cliente: state.global.clienteUnico,
		tid: state.global.tid,
		test11: state,
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
	  	dispatch({ type: "LOADER", show: show });
		}
	};
};

class MisFormatosFrame extends React.Component {

  componentDidMount = () => {
  };

  componentWillUnmount() {}

  onLoadIframe = () => {
	const polizasProps = this.props.test11.polizas.gm;
	const win = document.getElementById("tarjetas-frame").contentWindow;
	win.postMessage(polizasProps,  servicios.corporativo);
  };

  getSrcDirectorio() {
  	let url = "";
	
  	switch (this.props.hashOne) {
  	case "aviso-accidentes":
  		url = "aviso-accidentes/PDC";
  		break;
  	case "ayuda-parto-cesarea":
  		url = "ayuda-parto-cesarea/PDC";
  		break;
  	case "informacion-bancaria":
  		url = "informacion-bancaria/PDC";
  		break;
  	case "reembolso-accidentes":
  		url = "reembolso-accidentes/PDC";
  		break;
	case "bandeja":
		url = "bandeja";
		break;
  	}

	const pathWithParams = `${servicios.formatos.endPoint}/${url}/${localStorage.getItem("refreshToken")}`;

	return pathWithParams;
  }

  render() {
  	const propsComunes = {
  		id: "tarjetas-frame",
		name: "tarjetas-frame",
  		ref: "iFrame",
  		frameBorder: "0",
  		width: "100%",
  		height: "1050px",
  		src: this.getSrcDirectorio(),
  		allow: "geolocation; camera; microphone",
  	};

  	return (
  		<iframe
  			{...propsComunes}
  			onLoad={this.onLoadIframe}
  		/>
  	);
  }
}

export default connect(mapState, mapDispatch)(MisFormatosFrame);



// WEBPACK FOOTER //
// ./src/gnp-mis-formatos/mis-formatos.frm.js